import React from "react";
import "./PraQuemFoiEscrito.css";
import SetaLado from '../../assets/imgs/seta-2.png';
import Angle from "../../assets/imgs/arrow.svg";

function PraQuemFoiEscrito() {
  return (
    <div className="pra-quem-container">
      <div className="pra-quem-content">
        <h2>Para quem foi escrito este livro?</h2>
        <div className="orange-line"></div>
        <h3>
          Escrito para auxiliar nos mais variados níveis acadêmicos (graduação,
          mestrado ou doutorado), e os mais variados tipos de alunos (aqueles
          sem tempo ou com todo tempo do mundo), o livro "Pesquisa Científica:
          Aspectos Práticos" foi feito para quem:
        </h3>
        <img alt='insigne' src={SetaLado}></img>
      </div>

      <div className="pra-quem-itens">
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Precisa desenvolver seu projeto de pesquisa, artigo, monografia
            (TCC), dissertação ou tese, mas não sabe por onde começar ou está
            travado no meio do caminho;
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Tem dificuldade de organizar as ideias e de colocar no papel (ou na
            tela do computador, né?);
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Sente-se perdido, sem orientação e se acha incapaz de fazer qualquer
            pesquisa;
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Está na pós-graduação e precisa entregar seu trabalho finalizado;
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Quer publicar trabalhos acadêmicos para ganhar pontuação em
            concursos públicos;
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Precisa fazer um projeto de pesquisa para entrar no Mestrado ou no
            Doutorado;
          </p>
        </span>
        <span>
          <img alt='insigne' src={Angle}></img>
          <p>
            Quer ter o seu artigo publicado nas melhores revistas acadêmicas
            para ser reconhecido e conhecido.
          </p>
        </span>
      </div>
    </div>
  );
}

export default PraQuemFoiEscrito;
